import React from "react";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { renderBoldText } from "../utils/helper";
import SourceDialog from "./SourceDialog";
import { useGlobalModalContext } from "../context/GlobalModalContext";
import ReactMarkdown from "react-markdown";
import SentimentFlag from "./SentimentFlag";

function News({ news }) {
  const { showModal } = useGlobalModalContext();
  const handleSourceClick = (metadata) => {
    showModal(<SourceDialog metadata={metadata} />);
  };

  return (
    <div className="bg-white">
      {/* <h2 className="text-lg font-bold mb-2 text-main">NEWS</h2> */}
      {/* <ul className='max-h-[55vh] overflow-y-scroll pb-4'> */}
      <ul>
        {news?.description?.map((item, index) => (
          <li key={index} className="pb-4">
            <div
              className="text-xs border rounded p-1"
              style={{
                borderColor: "#A6A6A6",
                borderLeft: `4px solid ${
                  item?.sentiment_flag?.toLowerCase() === "positive"
                    ? "#4CAF50"
                    : item?.sentiment_flag?.toLowerCase() === "negative"
                    ? "#F15A23"
                    : "#A6A6A6"
                }`,
              }}
            >
              <div>
                {/* <SentimentFlag sentimentFlag={item.sentiment_flag} /> */}
                {item.title && (
                  <span className="font-bold px-2">{item.title} : </span>
                )}
              </div>
              <div className="px-2">
                <ReactMarkdown>{item.text}</ReactMarkdown>
              </div>
              <div
                className="text-right"
                style={{ cursor: "pointer" }}
                onClick={() => handleSourceClick(item.metadata)}
              >
                <u>
                  <i>Source {item.source_name}</i>
                </u>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default News;
